import React, { useEffect, useState } from "react";
import { fetchCourseVideoByCourseId } from "../../api/courseVideoApi";
import Loading from "../common/Loading";
import { Link, useNavigate } from "react-router-dom";
import ToastService from "../../services/ToastService";
import Modal3Js from "../Modal3Js";
import { useSelector } from "react-redux";

const CourseDetailChapter = ({ courseId }) => {

  const user = useSelector((state) => state.user.user);
  const [dataCourseVideo, setDataCourseVideo] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const fetchDataCourseVideo = async () => {

    try {
      const data = await fetchCourseVideoByCourseId({ courseId: courseId, userId: user && user.guid });

      if (data) {
        setDataCourseVideo(data);
        setLoading(false);
      }

    } catch (error) {
      if (error.code === "ERR_NETWORK") {
        ToastService.Error(error.message);
        return;
      }
      setIsModalOpen(true)
      console.log(error);
      ToastService.Error(error.response.data.message);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(fetchDataCourseVideo, 500);
  }, []);

  const handleNavigateTo = (item) => {
    if (item.isOpenFormAddMoney) {
      setIsModalOpen(true)
    } else {
      navigate('/course/' + courseId + '/lessons/' + item.id)
    }
  }


  return (
    <>
      {
        isModalOpen && <Modal3Js
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          title="Thông báo"
          submitText="Confirm"
          cancelText="Cancel"
        >

          <p>Hãy <Link to={'/course/' + courseId} data-router-disabled="">mua khóa học này</Link> hoặc <Link to={'/pricing'} data-router-disabled="">nâng cấp</Link> lên gói Gold hoặc Diamond để xem video này!
          </p>
          <p>Nếu chưa có tiền trong tài khoản, <Link to={'/account/mywallet'} data-router-disabled="">bấm vào đây</Link> để nạp tiền vào tài khoản.
          </p>


          <div className="buttons">

            {/* <Link to="/account/addmoney" data-router-disabled="" className="button is-purple">
                <span className="hover"></span>
                <span className="label">


                  Nạp tiền


                </span>
              </Link> */}

            <button className="js-close button" onClick={() => {
              setIsModalOpen(false)
            }}>
              <span className="hover"></span>
              <span className="label">
                Đóng
              </span>
            </button>

          </div>
        </Modal3Js>
      }

      {isLoading ? (
        <Loading />
      ) : (
        dataCourseVideo && (
          <>
            <section
              className="presentation js-anchor pb-20 mt-10"
              data-main-section
              id="presentation"
              data-slug="presentation"
            >
              <div className="content">
                <div className="js-stats numbers">
                  <div className="number">
                    <div className="js-value value">
                      {dataCourseVideo.totalChapter}
                    </div>
                    <div className="label">
                      Chapters{" "}
                      <span className="icon is-book">
                        <svg
                          width="19"
                          height="21"
                          viewBox="0 0 19 21"
                          fill="none"
                        >
                          <path
                            d="M17.9846 14.0692H3.95385C2.32248 14.0692 1 15.3917 1 17.0231M17.9846 14.0692V18.5C17.9846 19.3157 17.3234 19.9769 16.5077 19.9769H3.95385C2.32248 19.9769 1 18.6544 1 17.0231M17.9846 14.0692V2.47692C17.9846 1.66124 17.3234 1 16.5077 1H5.8M1 17.0231V3.95385C1 2.32248 2.32248 1 3.95385 1H5.8M9.54969 5.43077H13.6M9.54969 9.86154H13.6M5.8 14.2V1"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="radial-glow"></div>
                  </div>
                  <div className="number">
                    <div className="js-value value">
                      {dataCourseVideo.totalLessons}
                    </div>
                    <div className="label">
                      Lessons{" "}
                      <span className="icon is-paper-lines">
                        <svg
                          width="18"
                          height="21"
                          viewBox="0 0 18 21"
                          fill="none"
                        >
                          <path
                            d="M12.0175 1.5V4.875C12.0175 5.49632 12.5341 6 13.1714 6H16.6328M14.9021 3.1875C14.3886 2.73951 13.8557 2.20817 13.5193 1.86307C13.2954 1.63344 12.9861 1.5 12.6612 1.5H3.94054C2.66607 1.5 1.63291 2.50735 1.6329 3.74999L1.63281 17.2499C1.6328 18.4926 2.66596 19.5 3.94044 19.5L14.3249 19.5C15.5993 19.5 16.6325 18.4927 16.6325 17.2501L16.6328 5.32297C16.6328 5.03531 16.5203 4.75879 16.3155 4.55169C15.9369 4.16873 15.3046 3.53861 14.9021 3.1875Z"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="radial-glow"></div>
                  </div>
                  {/* <div className="number">
                    <div className="js-value value">sup</div>
                    <div className="label">
                      Hours <span className="optional">of tutorial</span>{" "}
                      <span className="icon is-player">
                        <svg
                          width="20"
                          height="14"
                          viewBox="0 0 20 14"
                          fill="none"
                        >
                          <rect
                            x="1"
                            y="1"
                            width="18"
                            height="12"
                            rx="2"
                            stroke="white"
                            stroke-width="2"
                          />
                          <path
                            d="M8.33008 5.43748C8.33008 4.5697 9.43448 4.13512 10.0804 4.74873L11.7253 6.31143C12.1257 6.69182 12.1257 7.30854 11.7253 7.68893L10.0804 9.25163C9.43448 9.86524 8.33008 9.43066 8.33008 8.56288V7.00018V5.43748Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                    </div>
                    <div className="radial-glow"></div>
                  </div> */}
                </div>
              </div>
            </section>{" "}
            <section
              className="summary clear-selection js-anchor js-summary"
              data-main-section
              id="summary"
              data-slug="summary"
            >
              <nav className="navigation js-navigation">
                <div className="mover">
                  {/* <a href="#" className="item js-item is-active">
                  <span className="number">01</span>
                </a>
                <a href="#" className="item js-item ">
                  <span className="number">02</span>
                </a>
                <a href="#" className="item js-item ">
                  <span className="number">03</span>
                </a>
                <a href="#" className="item js-item ">
                  <span className="number">04</span>
                </a>
                <a href="#" className="item js-item ">
                  <span className="number">05</span>
                </a>
                <a href="#" className="item js-item ">
                  <span className="number">06</span>
                </a>
                <a href="#" className="item js-item ">
                  <span className="number">07</span>
                </a> */}
                </div>
              </nav>

              <div className="chapters js-chapters">
                {dataCourseVideo &&
                  dataCourseVideo.courseVideos.map((item, index) => {
                    return (
                      <>
                        <div className="chapter-container js-item" key={index}>
                          <div className="illustration">
                            <div className="radial-glow"></div>
                            {/* <img
                              className="js-lazy lazy"
                              src="assets/images/chapters/chapter-01.webp"
                              srcset="/assets/images/chapters/chapter-01@2x.webp 2x"
                              alt="Basics 3D illustration"
                            /> */}
                          </div>
                          <div className="js-chapter chapter" data-index="01">
                            <h3 className="section-title element delay-1">
                              {item.title}
                            </h3>
                            <div className="information element delay-3">
                              <span className="format-icon">
                                <svg
                                  width="18"
                                  height="25"
                                  viewBox="0 0 18 25"
                                  fill="none"
                                >
                                  <path
                                    d="M6 16.0469H13"
                                    stroke="#ffffff"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                  <path
                                    d="M6 19.0469H13"
                                    stroke="#ffffff"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                  />
                                  <path
                                    d="M1 3.04687C1 4.15144 1.89543 5.04688 3 5.04688H17V1.12851C17 1.08342 16.9635 1.04687 16.9184 1.04687H3C1.89543 1.04687 1 1.94231 1 3.04687V3.04687Z"
                                    stroke="#ffffff"
                                    stroke-width="2"
                                  />
                                  <path
                                    d="M11 10.9288L13 9.92884V6.04688H9V9.92884L11 10.9288Z"
                                    stroke="#ffffff"
                                    stroke-width="2"
                                  />
                                  <path
                                    d="M1 3.04688V21.0469C1 22.1514 1.89543 23.0469 3 23.0469H16C16.5523 23.0469 17 22.5992 17 22.0469V3.04688"
                                    stroke="#ffffff"
                                    stroke-width="2"
                                  />
                                </svg>
                              </span>
                              <pre>
                                {item.totalLessons} lessons
                                {/* — 10h 12m  */}
                                {/* <span className="optional"> of tutorial</span> */}
                              </pre>
                            </div>
                            {/* <div className="description element delay-2">
                              <p>
                                Create your first scene and understand
                                fundamentals like <strong>cameras</strong>,{" "}
                                <strong>geometries</strong>,{" "}
                                <strong>materials</strong>,{" "}
                                <strong>textures</strong>.
                                <br />
                                Add a <strong>debug panel</strong>,{" "}
                                <strong>animate</strong> everything and put your
                                project online.
                              </p>
                            </div> */}
                            <div className="lessons">
                              {item.children &&
                                item.children.map(
                                  (itemChildren, indexChild) => {
                                    return (
                                      <>
                                        <a
                                          className="lesson element delay-4"
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleNavigateTo(itemChildren)
                                          }}
                                          data-router-disabled
                                        >
                                          <div className="column lesson-number">
                                            {indexChild + 1}
                                          </div>
                                          <div className="column lesson-title-badges">
                                            <div className="title is-public">
                                              {itemChildren.title}
                                            </div>
                                            <div className="badges">
                                              {itemChildren.isPreview ? (
                                                <span className="badge is-free">
                                                  free
                                                </span>
                                              ) : (
                                                <span className="badge is-sneak-peek">
                                                  sneak peek
                                                </span>
                                              )}
                                            </div>
                                          </div>
                                          <div className="column lesson-duration">
                                            {/* 35m */}
                                          </div>
                                        </a>
                                      </>
                                    );
                                  }
                                )}
                            </div>
                          </div>{" "}
                        </div>
                      </>
                    );
                  })}
              </div>
            </section>{" "}
          </>
        )
      )}
    </>
  );
};

export default CourseDetailChapter;
